// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-S":"S_dpu-detail-S__wZxk1"};